module.exports = __webpack_public_path__ + "img/food-delivery.8ca28be0.png";